import { z } from "zod";

/** 收货地址。访客保存在本机；登录用户由服务端按会话归属保存。 */
export const shippingAddressSchema = z.object({
  recipientName: z.string().trim().min(1).max(32),
  phone: z.string().regex(/^1\d{10}$/, "请输入有效的手机号"),
  province: z.string().trim().min(1).max(32),
  city: z.string().trim().min(1).max(32),
  district: z.string().trim().min(1).max(32),
  detail: z.string().trim().min(1).max(120),
});

export type ShippingAddressPayload = z.infer<typeof shippingAddressSchema>;

/**
 * 运费状态必须显式表达：当前没有配置真实承运规则时不返回假金额。
 * READY 表示运费确定；UNSUPPORTED_REGION 表示当前规则不配送。
 */
export const shippingStatusSchema = z.enum([
  "ADDRESS_REQUIRED",
  "MANUAL_CONFIRMATION",
  "READY",
  "UNSUPPORTED_REGION",
]);
export type ShippingStatus = z.infer<typeof shippingStatusSchema>;
